<ds-modal [modalInput]="modalConfig" (visibleChange)="onVisibleChange($event)">
  <ng-container modal-body>
    @if (mode == "import") {
      <div class="secondary-info-container --borderless">
        <ul class="ds-info-text --icon-bullet --primary">
          <li>{{ 'cc_transactions_free_remaining_note' | translate: { count: remainingTransactions } }}</li>
          <li>{{ 'cc_transactions_partial_import_note' | translate: { fileCount: transactionCount, count: remainingTransactions } }}</li>
          <li>{{ 'cc_transactions_subscribe_for_all_note' | translate }}</li>
        </ul>
      </div>
    }

    @if (mode == "freeLowBalance") {
      <div class="d-flex gap-16 mb-3">
        <div class="border-content__area p-3 gap-4 w-100pc">
          <h6 class="title-14">{{ 'pliant_remaining_transactions' | translate }}</h6>
          <p class="paragraph-14">{{ remainingTransactions }}</p>
        </div>
        <div class="border-content__area p-3 gap-4 w-100pc">
          <h6 class="title-14">{{ 'cc_transactions_free_limit_label' | translate }}</h6>
          <p class="paragraph-14">50</p>
        </div>
      </div>
      <div class="secondary-info-container --borderless">
        <ul class="ds-info-text --icon-bullet --primary">
          <li>{{ 'cc_transactions_remaining_note' | translate: { count: remainingTransactions } }}</li>
          <li>{{ 'cc_transactions_subscribe_unlock_note' | translate }}</li>
        </ul>
      </div>
    }

    @if (mode == "noPackage") {
      <div class="secondary-info-container --borderless">
        <ul class="ds-info-text --icon-bullet --primary">
          <li>{{ 'cc_transactions_none_available_note' | translate }}</li>
          <li>{{ 'cc_transactions_subscribe_unlock_note' | translate }}</li>
        </ul>
      </div>
    }

    @if (mode == "paidLowBalance") {
      <div class="d-flex gap-16 mb-3">
        <div class="border-content__area p-3 gap-4 w-100pc">
          <h6 class="title-14">{{ 'pliant_remaining_transactions' | translate }}</h6>
          <p class="paragraph-14">{{ remainingTransactions }}</p>
        </div>
        <div class="border-content__area p-3 gap-4 w-100pc">
          <h6 class="title-14">{{ 'cc_transactions_minimum_balance_label' | translate }}</h6>
          <p class="paragraph-14">{{ threshold }}</p>
        </div>
      </div>
      <div class="secondary-info-container --borderless">
        <ul class="ds-info-text --icon-bullet --primary">
          <li>{{ 'cc_transactions_balance_dropped_note' | translate }}</li>
          <li>{{ 'cc_transactions_complete_payment_note' | translate }}</li>
        </ul>
      </div>
    }
  </ng-container>

  <div modal-footer>
    @if (mode == "import" && remainingTransactions > 0) {
      <button class="btn btn-primary-outline" (click)="fnImportFreeTransactions()">
        {{ 'cc_transactions_import_free' | translate }}
      </button>
    }
    <button class="btn btn-primary w-45pc" (click)="fnCompletePayment()">
      @if (mode == "paidLowBalance") {
        {{ 'cc_transactions_complete_payment' | translate }}
      } @else {
        {{ 'cc_transactions_subscribe_now' | translate }}
      }
    </button>
  </div>
</ds-modal>
